<template>
<div :class="customerInfoStepClass"><div class="step-body">
    <div class="row">
        <div class="col-lg-1"><h4 class="step-num">2</h4></div>
        <div class="col-lg-11">
            <div class="step-box">
                <h4 class="step-title">Customer Info</h4>
                <div v-if="showCustomerStep" class="customer-fields">
                    <div v-if="confirmed">
                        <customer-info></customer-info>
                    </div>
                    <div class="row" v-else>
                        <form-field
                            v-for="field in customerInfo"
                            :key="field.id"
                            :index="field.id"
                            :field="field"
                        ></form-field>
                        <div class="col-lg-12">
                            <input type="submit" :class="submitClass" :value="submitText" :disabled="disableSubmit">
                            <div v-if="submitted" class="spinner-border" role="status" style="display:inline-block;margin-left:5px">
                              <span class="sr-only">Loading...</span>
                            </div>
                            <div class="invalid-input" v-if="errorsExist">Please correct the errors above to submit. Thank you.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div></div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FormField from '../FormField';
import CustomerInfo from './CustomerInfo';
import formMixin from '../../mixins/formMixin';
import schedulingMixin from '../../mixins/schedulingMixin';

export default {
  mixins: [formMixin,schedulingMixin],
  data() {
    return {
      errors: [],
      height: '',
    };
  },
  computed: {
    ...mapGetters({
      formErrors: 'fieldsWithErrors',
      userInput: 'response',
    }),
    ...mapGetters('form', [
      'fields',
      'redirect',
      'inline_title',
      'inline_message',
      'submit_text'
    ]),
    ...mapState('form', { form: 'form', formId: 'formId', confirmed: 'confirmed', submitted: 'submitted' }),
    ...mapState('scheduling', { step: 'step' }),
    isEventForm() {
      return this.form.integrationFormType == 'event';
    },
    customerInfoStepClass() {
        return {
            "scheduling-service-form-step":true,
            "step":true,
            "customer-info-step":true,
            "open": this.showCustomerStep && !this.confirmed
        }
    },
    submitText() {
        return !this.submit_text || this.submit_text == 'Submit' ? 'Schedule Booking' : this.submit_text;
    }
  },
  components: {
    FormField,
    CustomerInfo
  },
};
</script>
<style>
/* A copy of btn but without a hover to work with other colors */
.btn-nohover {
  display: inline-block;
  font-weight: 400;
  /* color: #212529; */
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* background-color: transparent; */
  border: 1px solid transparent;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.customer-fields .madform-submit {
    padding: 16px 20px;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgba(10, 64, 99, 0.15);
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: center;
    color: #e5f0fa;
}
.customer-fields label {
    margin-bottom: 0;
}
.customer-fields .form-group {
    margin-bottom:24px;
}
.customer-fields .required {
    color: red;
}
</style>
